export default __webpack_public_path__ + "static/back-to-top-51e05fd0dcf44d7a8e59547baa171038.svg";